import axios from "axios";
import { apiUrl } from "../domain";
import STORE from "../store/index";
// You can use your own logic to set your local or production domain
const baseDomain = apiUrl;
// The base URL is empty this time due we are using the jsonplaceholder API
const baseURL = `${baseDomain}`;

const instance = axios.create({
  baseURL,
});

instance.interceptors.response.use(
  async (response) => {
    // @ts-ignore
    const currentTime = parseInt(Date.now() / 1000);
    // @ts-ignore
    if (
      // @ts-ignore
      currentTime - 13600 > STORE.state.token_refreshed &&
      // @ts-ignore
      STORE.state.token_refreshed != 0
    ) {
      STORE.dispatch("setTokenRefreshTime", currentTime);
      try {
        // @ts-ignore
        if (STORE.state.token) {
          await instance.post("/api/admin/refresh-token").then((resp) => {
            const newToken = resp.data.new_token;

            STORE.dispatch("setToken", newToken);
          });
        }
      } catch (error) {
        alert(error);
      }
    }

    return response;
  },
  function (error) {
    if (error && error.response && error.response.data) {
      if (
        error.response.data.message == "Token has expired" ||
        error.response.data.error == "token_expired" ||
        error.response.data.message == "TokenInvalidException"
      ) {
        localStorage.clear();
        STORE.dispatch("setTokenRefreshTime", 0);
        document.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
